import { render } from "./NetPriceTable.vue?vue&type=template&id=73816719"
import script from "./NetPriceTable.vue?vue&type=script&lang=js"
export * from "./NetPriceTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/net-price/NetPriceTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73816719"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73816719', __exports__)) {
    api.reload('73816719', __exports__)
  }
  
  module.hot.accept("./NetPriceTable.vue?vue&type=template&id=73816719", () => {
    api.rerender('73816719', render)
  })

}


export default __exports__